import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeProject } from '../../../../types/uncinc_profile/nodes';
import { ParagraphsRenderer } from '../../../../components';

import './style.scss';

interface NodeProjectPageProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeProject>;
}

const NodeProjectPage: React.FC<NodeProjectPageProps> = ({ entity }) => {
  const { t } = useTranslation();
  const classes = classNames('NodeProjectPage');
  const project = entity.toJS();
  const title = project.title[0].value;
  const image = project.field_media_item[0]?.entity.field_media_image[0]?.source;
  const body = project.body[0]?.processed;
  const link = project.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeProjectPage__hero">
        {image && (
          <div className="NodeProjectPage__hero__image">
            <Image
              src={image}
              alt={title}
              lazyload={false}
            />
          </div>
        )}
        <div className="NodeProjectPage__hero__text">
          <h1 itemProp="name">{title}</h1>
          {body && (
            <WysiwygField
              property="schema:text"
              html={body}
            />
          )}
          {linkUrl && (
            <CoreLink to={linkUrl}>
              {linkTitle || t('general.read_more')}
            </CoreLink>
          )}
        </div>
      </div>

      <ParagraphsRenderer className="NodeProjectPage__paragraphs" paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeProjectPage;
